import workshop01 from '../images/workshop_images/workshop01.jpg';
import workshop02 from '../images/workshop_images/workshop02.jpg';
import workshop03 from '../images/workshop_images/workshop03.png';
import workshopPoster from '../images/workshop_images/workshop-poster.jpg';

/**
 * Fallback workshops when API returns empty / fails.
 * Matches the known Anuyog workshop lineup (static pages 01–04).
 */
const staticWorkshops = [
  {
    id: 26,
    title: 'Natural Health Simplified',
    slug: 'natural-health-simplified',
    subtitle: 'Unlock the Why, What & How of Early Healthy Living',
    duration: '90 minutes',
    date: '2026-05-03T00:00:00.000000Z',
    start_time: '14:00:00.000000',
    end_time: '15:30:00.000000',
    course_fee_original: '799.00',
    course_fee_discounted: '199.00',
    languages: ['English', 'Hindi'],
    location: 'online',
    cover_photo: null,
    cover_image: workshop01,
    tagline: 'Learn to take charge of your health with natural living.',
  },
  {
    id: 27,
    title: 'Healing Simplified',
    slug: 'healing-simplified',
    subtitle: "Unlock Healing with Nature's Cure",
    duration: '90 minutes',
    date: '2026-05-17T00:00:00.000000Z',
    start_time: '14:00:00.000000',
    end_time: '15:30:00.000000',
    course_fee_original: '799.00',
    course_fee_discounted: '199.00',
    languages: ['English', 'Hindi'],
    location: 'online',
    cover_photo: null,
    cover_image: workshop02,
    tagline: 'Learn to take charge of your health with natural healing.',
  },
  {
    id: 28,
    title: 'Gardening Simplified',
    slug: 'gardening-simplified',
    subtitle: 'Unlock the Secrets to Grow Your Own Healthy Harvest',
    duration: '90 minutes',
    date: '2026-05-31T00:00:00.000000Z',
    start_time: '19:00:00.000000',
    end_time: '20:30:00.000000',
    course_fee_original: '799.00',
    course_fee_discounted: '199.00',
    languages: ['English', 'Hindi'],
    location: 'online',
    cover_photo: null,
    cover_image: workshop03,
    tagline: 'Learn to take charge of your health with your own natural produce.',
  },
  {
    id: 25,
    title: 'Healthy & Sustainable Living Spaces Simplified',
    slug: 'healthy-sustainable-living-spaces-simplified',
    subtitle:
      'Discover ways to transform your living spaces to a more mindful and environmentally conscious spaces',
    duration: '90 minutes',
    date: '2026-06-14T00:00:00.000000Z',
    start_time: '19:00:00.000000',
    end_time: '20:30:00.000000',
    course_fee_original: '799.00',
    course_fee_discounted: '199.00',
    languages: ['English', 'Hindi'],
    location: 'online',
    cover_photo: null,
    cover_image: workshopPoster,
    tagline:
      'Learn to alter your physical surroundings for spiritual, mental and physical wellbeing',
  },
];

/** Shared static FAQs (same as Healing / Gardening static detail pages). */
export const staticWorkshopFaqs = [
  {
    title: 'What happens after I register?',
    content:
      'After you submit your details through the Contact Us form, our team will provide you with payment instructions. Complete the payment and share the screenshot with us. Your seat will be confirmed once the payment is verified.',
  },
  {
    title: 'How can I stay connected after the workshop?',
    content:
      'You can join Anuyog’s WhatsApp Group (https://chat.whatsapp.com/JEe0oM19XXd4LHjicaIzgf) to continue your journey toward natural living with like-minded individuals.',
  },
  {
    title: 'Does the workshop offer a recorded session or a live session?',
    content:
      'The workshop is conducted live by our expert facilitators, providing real-time interaction.',
  },
  {
    title: 'How can I prepare for the workshop?',
    type: 'list',
    content: [
      'Ensure a stable internet connection for the online sessions.',
      'Keep a notebook and pen handy for taking notes.',
      'Be ready to participate actively and implement the learnings.',
    ],
  },
  {
    title: 'Can I get a refund if I cannot attend?',
    content:
      'Refunds are not available, but you can transfer your spot to someone else if you notify us in advance.',
  },
  {
    title: 'Can I access recordings if I miss a session?',
    content:
      'Currently, live participation is encouraged for the best experience. Recordings may be offered in future workshops.',
  },
  {
    title: 'Will there be an interactive component?',
    content:
      'Yes! Each day includes an interactive Q&A session where you can ask questions and clarify your doubts.',
  },
  {
    title: 'Will I receive a confirmation email after registering?',
    content:
      'Yes, once you complete the registration process, you will receive a confirmation email with all the necessary details about the workshop, including the schedule and joining instructions. Make sure to check your inbox (and spam folder) for this email.',
  },
];

export default staticWorkshops;

export function resolveWorkshopCover(workshop, fallbackImage) {
  if (workshop?.cover_image) return workshop.cover_image;
  if (workshop?.cover_photo) {
    if (
      workshop.cover_photo.startsWith('http://') ||
      workshop.cover_photo.startsWith('https://')
    ) {
      return workshop.cover_photo;
    }
    const mediaBase = (
      process.env.REACT_APP_MEDIA_BASE_URL ||
      process.env.REACT_APP_API_BASE_URL ||
      'https://admin.anuyog.co'
    ).replace(/\/$/, '');
    const path = workshop.cover_photo.replace(/^\/+/, '');
    return `${mediaBase}/${path}`;
  }
  return fallbackImage;
}
